import { Grid, makeStyles } from '@material-ui/core';
import { Query } from 'hooks/useTableFilters';
import { getDashboardRequest } from 'modules/advisors/actions';
import { QueryProps } from 'modules/advisors/endpoints';
import React from 'react';
import { connect } from 'react-redux';
import PendingCard from './AdvisorCard/PendingCard';
import SavingsCard from './AdvisorCard/SavingsCard';
import styles from './styles';

const useStyles = makeStyles(styles);

interface AdvisorCardsProps {
  query: Query;
  getDashboardRequest: (query: QueryProps) => void;
}

const AdvisorCards = ({ query, getDashboardRequest }: AdvisorCardsProps) => {
  const classes = useStyles();

  React.useEffect(() => {
    getDashboardRequest({
      ...query,
    });
  }, [getDashboardRequest, query]);

  return (
    <Grid container justify="center" className={classes.cards}>
      <PendingCard />
      <SavingsCard />
    </Grid>
  );
};

export default connect(null, { getDashboardRequest })(AdvisorCards);
